import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { SharedButtonComponent } from './shared-button/shared-button.component';
import { SharedDialogComponent } from './shared-dialog/shared-dialog.component';
import { SharedErrorDialogComponent } from './shared-error-dialog/shared-error-dialog.component';
import { SharedProfileComponent } from './shared-profile/shared-profile.component';
import { SharedEmptyMessageComponent } from './shared-empty-message/shared-empty-message.component';
import { SharedSummaryItemComponent } from './shared-summary-item/shared-summary-item.component';
import { SharedIdComponent } from './shared-id/shared-id.component';
import { SharedCopySnackbarComponent } from './shared-copy-snackbar/shared-copy-snackbar.component';
import { SharedStoreLogoComponent } from './shared-store-logo/shared-store-logo.component';
import { SharedOrderChannelComponent } from './shared-order-channel/shared-order-channel.component';
import { SharedOrderOriginComponent } from './shared-order-origin/shared-order-origin.component';
import { SharedPillComponent } from './shared-pill/shared-pill.component';
import { SharedCountryPrefixComponent } from './shared-country-prefix/shared-country-prefix.component';
import { SharedInfoComponent } from './shared-info/shared-info.component';
import { SharedInfoCopyComponent } from './shared-info-copy/shared-info-copy.component';
import { SharedStatusIndicatorComponent } from './shared-status-indicator/shared-status-indicator.component';

@NgModule({
  declarations: [
    SharedButtonComponent,
    SharedDialogComponent,
    SharedErrorDialogComponent,
    SharedProfileComponent,
    SharedEmptyMessageComponent,
    SharedSummaryItemComponent,
    SharedIdComponent,
    SharedCopySnackbarComponent,
    SharedStoreLogoComponent,
    SharedOrderChannelComponent,
    SharedOrderOriginComponent,
    SharedPillComponent,
    SharedCountryPrefixComponent,
    SharedInfoComponent,
    SharedInfoCopyComponent,
    SharedStatusIndicatorComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    LoadingModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatAutocompleteModule,
  ],
  exports: [
    SharedButtonComponent,
    SharedDialogComponent,
    SharedErrorDialogComponent,
    SharedProfileComponent,
    SharedEmptyMessageComponent,
    SharedSummaryItemComponent,
    SharedIdComponent,
    SharedStoreLogoComponent,
    SharedOrderChannelComponent,
    SharedOrderOriginComponent,
    SharedPillComponent,
    SharedCountryPrefixComponent,
    SharedInfoComponent,
    SharedInfoCopyComponent,
    SharedStatusIndicatorComponent,
  ],
})
export class SharedModule {}
